import { render, staticRenderFns } from "./BasicContextElement.vue?vue&type=template&id=6d6619d4&scoped=true&"
import script from "./BasicContextElement.vue?vue&type=script&lang=js&"
export * from "./BasicContextElement.vue?vue&type=script&lang=js&"
import style0 from "./BasicContextElement.vue?vue&type=style&index=0&id=6d6619d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6619d4",
  null
  
)

export default component.exports